import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
type TickerItem = {
  symbol: string;
  price: string;
  change: number;
  currency: string;
};
const tickerData: TickerItem[] = [{
  symbol: 'BTC/PLN',
  price: '412,847',
  change: 2.34,
  currency: 'PLN'
}, {
  symbol: 'ETH/PLN',
  price: '14,892',
  change: -1.12,
  currency: 'PLN'
}, {
  symbol: 'WIG20',
  price: '2,456',
  change: 0.87,
  currency: 'PLN'
}, {
  symbol: 'EUR/PLN',
  price: '4.31',
  change: -0.23,
  currency: 'PLN'
}, {
  symbol: 'USD/PLN',
  price: '3.98',
  change: 0.45,
  currency: 'PLN'
}, {
  symbol: 'GOLD',
  price: '9,847',
  change: 1.56,
  currency: 'PLN'
}, {
  symbol: 'SP500',
  price: '5,892',
  change: 0.92,
  currency: 'USD'
}, {
  symbol: 'CDR',
  price: '187.40',
  change: 3.21,
  currency: 'PLN'
}];
export function LiveTicker() {
  const duplicatedData = [...tickerData, ...tickerData];
  return <div className="w-full bg-gray-900/80 backdrop-blur-sm border-y border-gray-800 overflow-hidden" data-id="element-180">
      <motion.div className="flex items-center py-3" animate={{
      x: [0, -50 * tickerData.length]
    }} transition={{
      x: {
        repeat: Infinity,
        repeatType: 'loop',
        duration: 30,
        ease: 'linear'
      }
    }} data-id="element-181">
        {duplicatedData.map((item, index) => <div key={`${item.symbol}-${index}`} className="flex items-center gap-3 px-6 border-r border-gray-800 whitespace-nowrap" data-id="element-182">
            <span className="font-mono text-sm text-gray-400" data-id="element-183">
              {item.symbol}
            </span>
            <span className="font-mono text-sm text-white font-medium" data-id="element-184">
              {item.price} {item.currency}
            </span>
            <span className={`flex items-center gap-1 font-mono text-xs ${item.change >= 0 ? 'text-emerald-400' : 'text-red-400'}`} data-id="element-185">
              {item.change >= 0 ? <TrendingUpIcon className="w-3 h-3" data-id="element-186" /> : <TrendingDownIcon className="w-3 h-3" data-id="element-187" />}
              {item.change >= 0 ? '+' : ''}
              {item.change}%
            </span>
          </div>)}
      </motion.div>
    </div>;
}